import React, { useCallback, useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { Link, makeStyles, Theme } from "@material-ui/core";
import { Avatar } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import styles from "./Profile.module.scss";
import { useHistory } from "react-router";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { AppDispatch } from "../../app/store";
import Paper from "@material-ui/core/Paper";

import {
  fetchAsyncGetUsersProfile,
  fetchAsyncLoginUser,
  selectLoginUser,
  selectSelectedProfile,
  editProfile,
  fetchAsyncGetLoginProfile,
  selectLoginUserProfile,
  clearSelectedProfile,
} from "../auth/authSlice";
import {
  selectSelectedUser,
  selectTargetUser,
  initialState,
  fetchAsyncGetRecords,
  fetchAsyncGetFollowList,
  selectFollowList,
  selectFollowAccount,
  setFollowAccount,
  clearSelectFollowList,
  selectSelectUserFollowList,
  fetchAsyncNewFollow,
  fetchAsyncDeleteFollow,
  fetchAsyncGetSelectFollowList,
  fetchAsyncGetOriginalRecords,
} from "../home/homeSlice";

const useStyles = makeStyles((theme: Theme) => ({
  iconBtn: {
    marginTop: theme.spacing(2),
    color: "#fff",
    backgroundColor: "#2699FB",
  },
  avatar: {
    width: "100%",
    height: "100%",
  },
  submit: {
    padding: theme.spacing(1, 5),
    backgroundColor: "#2699FB",
  },
  submitContainer: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: theme.spacing(2),
  },
  headerBack: {
    paddingLeft: theme.spacing(3),
  },
  headerSubmit: {
    paddingRight: theme.spacing(3),
  },
  headerLogout: {
    display: "flex",
    justifyContent: "flex-end",
  },
  logoutIcon: {
    backgroundColor: "transparent",
    color: "dimgray",
    marginTop: 4,
    border: "none",
    outline: "none",
    cursor: "pointer",
    marginRight: theme.spacing(2),
  },
  follow: {
    color: "#444444",
    fontSize: 16,
  },
  followContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end",
    cursor: "pointer",
    paddingRight: theme.spacing(4),
  },
  followBtn: {
    marginRight: theme.spacing(2),
    color: "#444444",
    backgroundColor: "#d1e8ff",
    border: "1px solid #444444",
    boxSizing: "border-box",
    borderRadius: 30,
    "&:hover": {
      backgroundColor: "#d1e8ff",
    },
  },
  followedBtn: {
    marginRight: theme.spacing(2),
    color: "#fff",
    border: "1px solid #6666ff",
    boxSizing: "border-box",
    borderRadius: 30,
  },
  container: {
    backgroundColor: "#f1f9ff",
  },
  whiteContainer: {
    height: "100vh",
    backgroundColor: "#ffffff",
    margin: theme.spacing(0, 1),
  },
  status: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  statusMain: {
    display: "flex",
  },
}));

const Profile = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch: AppDispatch = useDispatch();
  const loginUser = useSelector(selectLoginUser);
  const selectedUser = useSelector(selectSelectedUser);
  const selectedProfile = useSelector(selectSelectedProfile);
  const followList = useSelector(selectFollowList);
  const loginUserProfile = useSelector(selectLoginUserProfile);
  const selectUserFollowList = useSelector(selectSelectUserFollowList);
  //フォローページからの遷移を確認
  const followAccount = useSelector(selectFollowAccount);
  //対象ユーザをフォローしているかどうか
  //フォローの削除にFollowのIDが必要になる
  const [isFollowed, setIsFollowed] = useState({ id: 0, flg: false });

  //プロフィール編集をクリック
  const handleEditProfile = async () => {
    // editedProfileに編集の対象ユーザを格納
    await dispatch(editProfile(loginUserProfile));
    history.push("/home/profile/edit");
  };
  //フォローをクリック時
  const handleProfileFollowList = async () => {
    history.push("/home/profile/follow");
  };

  const handleProfileSelectFollowList = async () => {
    history.push("/home/profile/follow");
  };
  //戻るボタン(selectedUserをリセットする)
  const backProfile = useCallback(() => {
    dispatch(selectTargetUser(initialState.selectedUser));
    dispatch(clearSelectedProfile());
    history.push("/home/search");
  }, [history, dispatch]);

  const backFollow = useCallback(() => {
    dispatch(setFollowAccount(false));
    dispatch(selectTargetUser(initialState.selectedUser));
    dispatch(clearSelectedProfile());
    dispatch(clearSelectFollowList());
    history.push("/home/profile/follow");
  }, [history, dispatch]);

  //月初取得関数
  const getFirstDate = (date: any) => {
    return new Date(date.getFullYear(), date.getMonth(), 1);
  };
  //月末取得関数
  const getLastDate = (date: any) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  };
  //ログアウト用
  const Logout = () => {
    localStorage.removeItem("localJWT");
    window.location.href = "/login";
  };

  //新規フォロー（profileのIDを渡す）
  const handleFollowUser = async () => {
    selectedProfile?.results[0].id &&
      (await dispatch(
        fetchAsyncNewFollow({ follow_target_id: selectedProfile.results[0].id })
      ));
  };
  //フォロー解除（FollowのIDを渡す）
  const handleUnFollowUser = async () => {
    await dispatch(fetchAsyncDeleteFollow(isFollowed.id));
  };

  //カレンダー確認(selectedUserが残っているため、該当ユーザのカレンダーを確認可能)
  const goCalender = useCallback(async () => {
    //ページ表示時のレコード取得（今月のレコード）
    const fetchBootLoader = async () => {
      let first_date = getFirstDate(new Date());
      let last_date = getLastDate(new Date());
      //カレンダーの表示対象を判別 selectedUserにidが存在する場合、他ユーザのレコードを取得
      let target_user_id =
        selectedUser.user_profile !== 0
          ? selectedUser.user_profile
          : loginUser.id;
      const para = {
        user_id: target_user_id,
        date_after: `${first_date.getFullYear()}-${
          first_date.getMonth() + 1
        }-${first_date.getDate()}`,
        date_before: `${last_date.getFullYear()}-${
          last_date.getMonth() + 1
        }-${last_date.getDate()}`,
      };
      await dispatch(fetchAsyncGetRecords(para));
      await dispatch(fetchAsyncGetOriginalRecords(para));
    };
    await fetchBootLoader();

    await history.push("/home");
  }, [history, dispatch]);

  //画面初期表示時、ログインユーザの情報を取得し格納
  //取得できない場合はJWTの有効期限切れのため、HOME画面へ遷移
  useEffect(() => {
    loginUser.id === 0 && dispatch(fetchAsyncLoginUser());
    if (selectedUser.user_profile === 0) {
      //ログインユーザのプロフィールデータがなかったら取得
      loginUserProfile.user_profile === 0 &&
        dispatch(fetchAsyncGetLoginProfile());
    } else {
      //他のユーザをセレクトしているが、プロフィールデータを取得できていなかった場合
      selectedProfile?.results[0]?.id === 0 &&
        dispatch(fetchAsyncGetUsersProfile(selectedUser.user_profile));
    }
  }, []);

  //フォローリスト取得処理
  useEffect(() => {
    //selectedProfileが変更したらfollowListを取得
    if (selectedUser.user_profile === 0) {
      //他のユーザーのプロフィール表示でない場合、
      //ログインユーザのfollowDataが取得できていない場合
      followList.count === 0 &&
        loginUserProfile.user_profile !== 0 &&
        dispatch(fetchAsyncGetFollowList(loginUserProfile.user_profile));
    } else {
      //他のユーザーのプロフィール表示の場合
      //該当ユーザーのfollowDataが取得できていない場合
      selectUserFollowList.count === 0 &&
        selectedUser.user_profile > 0 &&
        dispatch(fetchAsyncGetSelectFollowList(selectedUser.user_profile));
    }
  }, [selectedProfile, loginUserProfile, dispatch]);

  useEffect(() => {
    //セレクトユーザが存在し、ログインユーザのフォロー数が0出ない場合、フォローリストに対象のセレクトユーザが存在するか確認
    //フォローボタンの切り替えを行う
    if (selectedUser.user_profile !== 0) {
      const targetUser = followList.results.find(
        (f) => selectedUser.user_profile === f.follow_target_user_profile
      );
      targetUser
        ? setIsFollowed({ id: targetUser.id, flg: true })
        : setIsFollowed({ id: 0, flg: false });
    }
  }, [followList, selectedUser]);

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12} component={Paper} elevation={6} square>
        <div className={classes.whiteContainer}>
          <div className={classes.header}>
            <div className={classes.headerBack}>
              {selectedUser.user_profile !== 0 &&
                (followAccount ? (
                  //フォローページからの遷移の場合は、followPageへ
                  <ArrowBackIcon onClick={backFollow} />
                ) : (
                  <ArrowBackIcon onClick={backProfile} />
                ))}
            </div>
            <div className={classes.headerLogout}>
              {selectedUser.user_profile === 0 && (
                <button onClick={Logout} className={classes.logoutIcon}>
                  <ExitToAppIcon fontSize="large" />
                </button>
              )}
            </div>
            {selectedUser.user_profile !== 0 &&
              loginUser.id !== selectedUser.user_profile &&
              (isFollowed.flg ? (
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.followedBtn}
                  onClick={handleUnFollowUser}
                >
                  フォロー中
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.followBtn}
                  onClick={handleFollowUser}
                >
                  フォローする
                </Button>
              ))}
          </div>
          <div className={styles.profile__img__container}>
            {selectedUser.user_profile === 0 ? (
              <Avatar
                src={
                  loginUserProfile?.img !== null
                    ? loginUserProfile?.img
                    : undefined
                }
                alt=""
                className={classes.avatar}
              />
            ) : (
              <Avatar
                src={
                  selectedProfile?.results[0]?.img !== null
                    ? selectedProfile?.results[0]?.img
                    : undefined
                }
                alt=""
                className={classes.avatar}
              />
            )}
          </div>

          {/* 他のユーザーでカレンダー表示ONの場合 */}
          {selectedUser.user_profile !== 0 &&
            selectedProfile?.results[0]?.calendar_hide_flg === "1" && (
              <Grid className={classes.submitContainer}>
                <div>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    onClick={goCalender}
                  >
                    カレンダーを確認する
                  </Button>
                </div>
              </Grid>
            )}
          <Grid container>
            <Grid item xs={12}>
              <div className={styles.profile__name}>
                {/* ログインユーザ名表示するか、選択ユーザ名を表示するか */}
                {selectedUser.user_profile === 0
                  ? loginUserProfile.username
                  : selectedProfile?.results[0]?.username}
              </div>
            </Grid>
            <div className={classes.status}>
              <div className={classes.statusMain}>
                <Grid item>
                  <div className={styles.profile__body}>
                    <span>height: </span>
                    {selectedUser.user_profile === 0 ? (
                      <span>
                        {loginUserProfile?.height
                          ? loginUserProfile?.height
                          : undefined}
                      </span>
                    ) : (
                      <span>
                        {selectedProfile?.results[0]?.height
                          ? `${selectedProfile?.results[0]?.height} cm`
                          : undefined}
                      </span>
                    )}
                  </div>
                </Grid>
                <Grid item>
                  <div
                    className={
                      styles.profile__body + " " + styles.profile__body__weight
                    }
                  >
                    <span>weight: </span>
                    {selectedUser.user_profile === 0 ? (
                      <span>
                        {loginUserProfile?.weight
                          ? loginUserProfile?.weight
                          : undefined}
                      </span>
                    ) : (
                      <span>
                        {selectedProfile?.results[0]?.weight
                          ? `${selectedProfile?.results[0]?.weight} kg`
                          : undefined}
                      </span>
                    )}
                  </div>
                </Grid>
              </div>
              <Grid item className={classes.followContainer}>
                {selectedUser.user_profile === 0 ? (
                  <Link
                    className={classes.follow}
                    onClick={handleProfileFollowList}
                  >
                    フォロー : <span>{followList.count}</span>
                  </Link>
                ) : (
                  <Link
                    className={classes.follow}
                    onClick={handleProfileSelectFollowList}
                  >
                    フォロー : <span>{selectUserFollowList.count}</span>
                  </Link>
                )}
              </Grid>
            </div>
          </Grid>

          <Grid item xs={12}>
            {selectedUser.user_profile === 0 ? (
              <div className={styles.profile__text}>
                {loginUserProfile?.text !== null
                  ? loginUserProfile?.text
                  : undefined}
              </div>
            ) : (
              <div className={styles.profile__text}>
                {selectedProfile?.results[0]?.text !== null
                  ? selectedProfile?.results[0]?.text
                  : undefined}
              </div>
            )}
          </Grid>
          <div className={classes.submitContainer}>
            {/* 表示しているのが自分のプロフィールの場合、編集ボタンを表示 */}
            {selectedUser.user_profile === 0 && (
              <Grid item xs={9}>
                <Button
                  variant="contained"
                  fullWidth
                  color="primary"
                  className={classes.iconBtn}
                  onClick={handleEditProfile}
                >
                  プロフィール編集
                </Button>
              </Grid>
            )}
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default Profile;
